import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// /home/ubuntu/avaai_dashboard/frontend/src/pages/ForgotPassword.tsx
import { useState } from "react";
import { Link } from "react-router-dom";
import { usePreferences } from "../context/PreferencesContext";
import { getAvaaioAuthCopy, interpolateAuthCopy, localizeAuthResponse, } from "../utils/avaaioAuthCopy";
const API_BASE = "";
export default function ForgotPassword() {
    const { preferences } = usePreferences();
    const copy = getAvaaioAuthCopy(preferences.language);
    const [email, setEmail] = useState("");
    const [msg, setMsg] = useState("");
    const [messageType, setMessageType] = useState("idle");
    const [loading, setLoading] = useState(false);
    async function handleReset() {
        if (loading)
            return;
        setLoading(true);
        setMsg(copy.forgot.sendingLink);
        setMessageType("idle");
        try {
            const res = await fetch(`${API_BASE}/api/v1/auth/forgot-password`, { credentials: "include",
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    email: email.trim(),
                    ui_language: copy.language,
                }),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) {
                throw new Error(localizeAuthResponse(data?.detail || data?.message, copy.forgot.unable, copy));
            }
            setMsg(copy.forgot.checkEmail);
            setMessageType("success");
        }
        catch (err) {
            setMsg(localizeAuthResponse(err?.message, copy.forgot.error, copy));
            setMessageType("error");
        }
        finally {
            setLoading(false);
        }
    }
    function goBack() {
        window.location.href = "/login";
    }
    return (_jsxs("div", { style: styles.page, children: [_jsx("div", { style: styles.bgGlowTop }), _jsx("div", { style: styles.bgGlowBottom }), _jsxs("div", { style: styles.card, children: [_jsx("div", { style: styles.brandLine, children: "AVAAIO\u2122" }), _jsx("h1", { style: styles.title, children: copy.forgot.title }), _jsx("p", { style: styles.subtitle, children: copy.forgot.subtitle }), _jsx("div", { style: styles.inputWrap, children: _jsx("input", { type: "email", placeholder: copy.forgot.emailPlaceholder, value: email, onChange: (e) => setEmail(e.target.value), autoComplete: "email", style: styles.input }) }), _jsx("button", { onClick: handleReset, style: {
                            ...styles.button,
                            ...(loading ? styles.buttonDisabled : {}),
                        }, disabled: loading, children: loading ? copy.forgot.sending : copy.forgot.send }), _jsx("button", { onClick: goBack, style: styles.backButton, children: copy.common.backLogin }), msg ? (_jsx("div", { style: {
                            ...styles.messageBox,
                            ...(messageType === "error"
                                ? styles.messageBoxError
                                : messageType === "success"
                                    ? styles.messageBoxSuccess
                                    : {}),
                        }, children: _jsx("p", { style: {
                                ...styles.messageText,
                                ...(messageType === "error"
                                    ? styles.messageTextError
                                    : messageType === "success"
                                        ? styles.messageTextSuccess
                                        : {}),
                            }, children: msg }) })) : null, _jsxs("div", { style: styles.legalFooter, children: [_jsx("div", { style: styles.legalPowered, children: copy.common.powered }), _jsx("div", { style: styles.legalTech, children: copy.common.builtOn }), _jsx("div", { style: styles.legalCopy, children: interpolateAuthCopy(copy.common.copyright, { year: new Date().getFullYear() }) }), _jsx("div", { style: styles.legalTrademark, children: copy.common.trademark }), _jsxs("div", { style: styles.legalLinks, children: [_jsx(Link, { to: "/privacy-policy", style: styles.legalLink, children: copy.common.privacy }), _jsx("span", { style: styles.legalSeparator, children: " | " }), _jsx(Link, { to: "/terms-and-conditions", style: styles.legalLink, children: copy.common.terms }), _jsx("span", { style: styles.legalSeparator, children: " | " }), _jsx(Link, { to: "/ai-disclaimer", style: styles.legalLink, children: copy.common.aiDisclaimer })] })] })] })] }));
}
const styles = {
    page: {
        minHeight: "100vh",
        width: "100%",
        position: "relative",
        overflow: "hidden",
        background: "radial-gradient(circle at top center, rgba(0,220,255,0.08), transparent 24%), linear-gradient(180deg, #00050d 0%, #000814 45%, #00030a 100%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "clamp(18px, 3vw, 32px)",
        boxSizing: "border-box",
        fontFamily: 'Inter, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
    bgGlowTop: {
        position: "absolute",
        top: "-10%",
        left: "50%",
        transform: "translateX(-50%)",
        width: "min(66vw, 760px)",
        height: "min(66vw, 760px)",
        borderRadius: "50%",
        background: "radial-gradient(circle, rgba(0,220,255,0.12) 0%, rgba(0,220,255,0.04) 36%, transparent 72%)",
        filter: "blur(28px)",
        pointerEvents: "none",
    },
    bgGlowBottom: {
        position: "absolute",
        bottom: "-18%",
        left: "50%",
        transform: "translateX(-50%)",
        width: "min(58vw, 640px)",
        height: "min(58vw, 640px)",
        borderRadius: "50%",
        background: "radial-gradient(circle, rgba(0,100,220,0.08) 0%, rgba(0,100,220,0.02) 40%, transparent 72%)",
        filter: "blur(28px)",
        pointerEvents: "none",
    },
    card: {
        position: "relative",
        zIndex: 1,
        width: "min(100%, 520px)",
        borderRadius: "24px",
        border: "1px solid rgba(35, 211, 238, 0.28)",
        background: "linear-gradient(180deg, rgba(8,16,28,0.94) 0%, rgba(4,9,18,0.97) 100%)",
        boxShadow: "0 0 0 1px rgba(255,255,255,0.03), 0 0 34px rgba(0,220,255,0.10), 0 22px 80px rgba(0,0,0,0.46)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        padding: "30px 24px 22px",
        boxSizing: "border-box",
        textAlign: "center",
    },
    brandLine: {
        textAlign: "center",
        fontSize: "0.88rem",
        letterSpacing: "0.32em",
        textTransform: "uppercase",
        color: "#7cf8ff",
        marginBottom: "12px",
        fontWeight: 800,
        fontFamily: '"Orbitron", Inter, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        textShadow: "0 0 12px rgba(0,255,255,0.22)",
    },
    title: {
        margin: "0 0 10px",
        fontSize: "clamp(2rem, 4vw, 2.7rem)",
        lineHeight: 1.08,
        color: "#efffff",
        fontWeight: 900,
        letterSpacing: "-0.02em",
        fontFamily: '"Orbitron", Inter, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        textShadow: "0 0 20px rgba(0,220,255,0.12)",
    },
    subtitle: {
        margin: "0 0 24px",
        fontSize: "0.98rem",
        lineHeight: 1.6,
        color: "rgba(215, 240, 245, 0.82)",
        fontWeight: 500,
    },
    inputWrap: {
        marginBottom: "14px",
    },
    input: {
        width: "100%",
        minHeight: "54px",
        padding: "0 16px",
        borderRadius: "16px",
        border: "1px solid rgba(90, 215, 255, 0.22)",
        background: "rgba(6, 14, 24, 0.92)",
        color: "#f3ffff",
        boxSizing: "border-box",
        outline: "none",
        fontSize: "0.98rem",
        fontWeight: 500,
        letterSpacing: "0.01em",
        boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.02)",
    },
    button: {
        width: "100%",
        minHeight: "54px",
        borderRadius: "16px",
        border: "none",
        background: "linear-gradient(90deg, #00d8ff 0%, #00ffee 55%, #7ffcff 100%)",
        color: "#04131a",
        fontSize: "1rem",
        fontWeight: 900,
        letterSpacing: "0.04em",
        cursor: "pointer",
        boxShadow: "0 0 18px rgba(0,255,255,0.18), 0 10px 26px rgba(0,0,0,0.22)",
    },
    buttonDisabled: {
        opacity: 0.62,
        cursor: "not-allowed",
        boxShadow: "none",
    },
    backButton: {
        width: "100%",
        minHeight: "48px",
        marginTop: "12px",
        borderRadius: "14px",
        border: "1px solid rgba(100, 220, 255, 0.20)",
        background: "rgba(10, 18, 30, 0.84)",
        color: "#b8fbff",
        fontSize: "0.95rem",
        fontWeight: 700,
        letterSpacing: "0.01em",
        cursor: "pointer",
    },
    messageBox: {
        marginTop: "16px",
        borderRadius: "16px",
        padding: "14px 14px",
        border: "1px solid rgba(255,255,255,0.06)",
        background: "rgba(255,255,255,0.03)",
    },
    messageBoxError: {
        background: "rgba(255, 72, 72, 0.08)",
        border: "1px solid rgba(255, 110, 110, 0.16)",
    },
    messageBoxSuccess: {
        background: "rgba(0, 255, 170, 0.08)",
        border: "1px solid rgba(80, 255, 200, 0.18)",
    },
    messageText: {
        margin: 0,
        fontSize: "0.94rem",
        lineHeight: 1.55,
        textAlign: "center",
        fontWeight: 600,
    },
    messageTextError: {
        color: "#ffb3b3",
    },
    messageTextSuccess: {
        color: "#baffea",
    },
    legalFooter: {
        marginTop: "18px",
        textAlign: "center",
        fontSize: "0.72rem",
        lineHeight: 1.5,
        color: "rgba(210,240,245,0.72)",
    },
    legalPowered: {
        marginBottom: "4px",
        fontWeight: 600,
    },
    legalTech: {
        fontSize: "11px",
        color: "rgba(255,255,255,0.72)",
        marginTop: "6px",
    },
    legalTrademark: {
        fontSize: "10px",
        color: "rgba(255,255,255,0.58)",
        marginTop: "4px",
    },
    legalCopy: {
        marginBottom: "6px",
    },
    legalLinks: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
    },
    legalLink: {
        color: "rgba(154,252,255,0.92)",
        textDecoration: "none",
        fontWeight: 700,
    },
    legalSeparator: {
        color: "rgba(154,252,255,0.42)",
        padding: "0 6px",
    },
};
